import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  VStack,
} from '@chakra-ui/react';
import { ContentCard } from '../Components/ContentCard';
import { LuCircleCheck } from 'react-icons/lu';

export function VerificationSuccess() {
  const location = useLocation();
  const navigate = useNavigate();

  const { state } = location;
  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get('type') || (state && state.type) || 'signup';
  const nextPage = searchParams.get('next') || 'signin';

  const [countdown, setCountdown] = React.useState(3);

  React.useEffect(() => {
    const redirectTimer = setTimeout(() => {
      if (countdown <= 0) {
        navigate(nextPage === 'signin' ? '/signin' : `/${nextPage}`);
      } else {
        setCountdown(countdown - 1);
      }
    }, 1000);
    return () => clearTimeout(redirectTimer);
  }, [navigate, nextPage, countdown]);

  const getVerificationDetails = () => {
    switch (type) {
      case 'recovery':
        return { title: 'Password Recovery Verified', message: 'Your password recovery request has been verified. You can now reset your password.', buttonText: 'Reset Password' };
      case 'signup':
      default:
        return { title: 'Email Verified Successfully', message: 'Your email has been successfully verified. You can now log in to your account.', buttonText: 'Sign In' };
    }
  };

  const { title, message, buttonText } = getVerificationDetails();

  const handleContinue = () => {
    navigate(type === 'recovery' ? '/reset-password' : '/signin');
  };

  return (
    <Container centerContent maxW="lg" py={{ base: '12', md: '24' }} px={{ base: '0', sm: '8' }}>
      <VStack w="full" spacing={8}>
        <ContentCard>
          <VStack spacing={6} alignItems="center" p={6}>
            <Box p={4} borderRadius="full" bg="green.50" border="2px" borderColor="green.200">
              <Box as={LuCircleCheck} boxSize="80px" color="green.500" />
            </Box>

            <Heading size="lg" textAlign="center" color="gray.900">{title}</Heading>

            <Text fontSize="md" textAlign="center" color="gray.700" mb={2}>{message}</Text>

            <Text fontSize="sm" color="blue.600" textAlign="center">
              Redirecting to sign in page in {countdown} second{countdown !== 1 ? 's' : ''}...
            </Text>

            <Button colorScheme="blue" size="lg" width="full" fontWeight="semibold" borderRadius="md" onClick={handleContinue}>
              {buttonText} Now
            </Button>
          </VStack>
        </ContentCard>
      </VStack>
    </Container>
  );
}

export default VerificationSuccess;
